import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface InboxItem {
  id: string;
  type: string | null;
  title: string | null;
  body: string | null;
  payload: { [key: string]: any };
  readAt: string | null;
  createdAt: string;
}

/** The mobile inbox (dswd-api `mobile/notifications`) plus the unread badge count. */
@Injectable({
  providedIn: 'root',
})
export class NotificationService {

  private unreadSource = new BehaviorSubject<number>(0);
  unreadCount$ = this.unreadSource.asObservable();

  constructor(private http: HttpClient) { }

  list(page = 1): Observable<any> {
    return this.http.get<any>(environment.apiUrl + `api/v1/mobile/notifications?page=${page}`);
  }

  refreshUnreadCount(): void {
    this.http.get<any>(environment.apiUrl + 'api/v1/mobile/notifications/unread-count')
      .subscribe({
        next: (res) => this.unreadSource.next(res?.details?.count ?? 0),
        error: () => {},
      });
  }

  markRead(id: string): Observable<any> {
    return this.http.patch<any>(environment.apiUrl + `api/v1/mobile/notifications/${id}/read`, {})
      .pipe(tap(() => this.unreadSource.next(Math.max(0, this.unreadSource.value - 1))));
  }

  markAllRead(): Observable<any> {
    return this.http.patch<any>(environment.apiUrl + 'api/v1/mobile/notifications/read-all', {})
      .pipe(tap(() => this.unreadSource.next(0)));
  }

  reset(): void {
    this.unreadSource.next(0);
  }
}
